import { useTranslation } from 'react-i18next'

import { useOutboundUuid, useUserData } from '../../../../../hooks'
import { isStaffUser } from '../../../../../utils/user'
import { EmailProfileMessagesList } from '../../../../Email'
import { PageEmptyState } from '../../../../PageEmptyState'
import { ProfileAISummaryWidget } from '../../../../Widget'

import { getMessageDropdownActions } from './RequestProfileTabEmailsThreadModalBody.utils'

import * as styles from './RequestProfileTabEmailsThreadModalBody.module.css'

import EmailIcon from '../../../../../icons/email.svg'

function RequestProfileTabEmailsThreadModalBody({
  containerRef,
  getMessageThresholdItemsProps,
  isInitiated,
  isReloadingThread,
  itemProps,
  loadingMore,
  mailUuid,
  messages,
  summaryProps,
}) {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const outboundUuid = useOutboundUuid()

  const isStaff = isStaffUser(currentUser)

  const isThreadLoading = !isInitiated || isReloadingThread

  const showEmptyState = !isThreadLoading && messages?.length === 0

  return (
    <div
      className={styles.RequestProfileTabEmailsThreadModalBody}
      ref={containerRef}
    >
      {showEmptyState ? (
        <PageEmptyState
          EntityIcon={EmailIcon}
          className={styles.emptyState}
          text={t('RequestProfile.TabEmailsThreadNotAvailableKey')}
        />
      ) : (
        <>
          {isStaff && !outboundUuid ? (
            <ProfileAISummaryWidget
              {...summaryProps}
              className={styles.summary}
              contentContainerProps={{
                className: styles.summaryContent,
              }}
              isSkeleton={isThreadLoading}
              key={mailUuid}
              loadButtonProps={{
                className: styles.summaryLoadButton,
              }}
            />
          ) : null}
          <EmailProfileMessagesList
            getMessageThresholdItemsProps={getMessageThresholdItemsProps}
            itemProps={{
              ...itemProps,
              headerProps: {
                ...itemProps?.headerProps,
                actionsProps: {
                  ...itemProps?.headerProps?.actionsProps,
                  getDropdownActions: getMessageDropdownActions,
                },
              },
            }}
            items={messages}
            loadingMore={loadingMore}
          />
        </>
      )}
    </div>
  )
}

export default RequestProfileTabEmailsThreadModalBody
